export default __webpack_public_path__ + "static/media/WhiteAgregarUsuario.b7b74c9f.svg";